import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { CustomerOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const CustomersSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(CustomerOptions).map((key) => ({
        id: key,
        label: t(`intake_form.customer_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default CustomersSelect;
